var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerCharge2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2345_64973)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 24.75C8.25 11.0786 19.342 0 33.0269 0C46.7118 0 57.8039 11.0786 57.8039 24.75C57.8039 38.4147 33.0269 66 33.0269 66C33.0269 66 8.25 38.4147 8.25 24.75ZM16.5067 24.75C16.5067 33.862 23.9082 41.25 33.0269 41.25C42.1524 41.25 49.5471 33.862 49.5471 24.75C49.5471 15.638 42.1524 8.25 33.0269 8.25C23.9014 8.25 16.5067 15.638 16.5067 24.75ZM28.9782 27.4676L43.8448 15.1994L46.6152 18.1555L30.8528 35.2601L29.311 36.935L27.8329 35.2046L19.4387 25.3989L22.1758 22.4344L28.9782 27.4676Z",
    fill: "#70B4F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2345_64973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCharge2);
export default __webpack_public_path__ + "static/media/marker-charge2.eba0661d04a25fcf1d9aa72abcd6eb98.svg";
export { ForwardRef as ReactComponent };